import { useEffect } from "react";
import { useSelector } from "react-redux";
import {getOneTrustLink, getOneTrustToken, setHeaderLoadType} from "../../slices/vehicleSlice";

const OneTrustContainer = () => {

    const oneTrustLink = useSelector(getOneTrustLink);
    const oneTrustToken = useSelector(getOneTrustToken);
    const headerLoadType = useSelector(setHeaderLoadType);

    useEffect(() => {
        if (headerLoadType != null) {
            const oneTrustContainer = document.createElement('div');
            oneTrustContainer.className = 'OneTrustContainer';

            const script1 = document.createElement('script');
            script1.src = oneTrustLink;
            script1.type = "text/javascript";

            const script2 = document.createElement('script');
            script2.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
            script2.type = "text/javascript";
            script2.charset = "UTF-8";
            script2.setAttribute('data-domain-script', oneTrustToken);

            const script3 = document.createElement('script');
            script3.type = "text/javascript";
            script3.innerHTML = `function OptanonWrapper() { }`;

            oneTrustContainer.appendChild(script1);
            oneTrustContainer.appendChild(script2);
            oneTrustContainer.appendChild(script3);

            document.body.appendChild(oneTrustContainer);

            return () => {
                document.body.removeChild(oneTrustContainer);
            };
        }
    }, [oneTrustLink, oneTrustToken, headerLoadType]);

    return null;
};

export default OneTrustContainer;